import { render, staticRenderFns } from "./Reclamation.vue?vue&type=template&id=5c215922&"
import script from "./Reclamation.vue?vue&type=script&lang=js&"
export * from "./Reclamation.vue?vue&type=script&lang=js&"
import style0 from "./Reclamation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports